



































































































import Vue from 'vue';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';
const Ripple = require('vue-ripple-directive');
import moment from 'moment';
import axios from 'axios';
import { mapState, mapActions, mapMutations } from 'vuex';
import { MonitorGroup, countyFilters, Monitor } from './types';

export default Vue.extend({
  components: {
    DatePicker,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    const date = moment().valueOf();
    let monitor: string | undefined;
    return {
      county: '',
      display: false,
      reportTypes: [
        { id: 'daily', txt: '日報' },
        { id: 'monthly', txt: '月報' },
      ],
      columns: Array<any>(),
      statRows: Array<any>(),
      rows: Array<any>(),
      form: {
        monitor,
        date,
        reportType: 'daily',
      },
    };
  },
  computed: {
    ...mapState('monitors', ['monitors']),
    pickerType(): string {
      if (this.form.reportType === 'daily') return 'date';
      return 'month';
    },
    canQuery(): boolean {
      if (this.form.monitor && this.form.reportType && this.form.date)
        return true;
      else return false;
    },
  },
  async mounted() {
    await this.fetchMonitors();
    if (this.monitors.length !== 0) {
      this.form.monitor = this.monitors[0]._id;
    }
    await this.fetchMonitorTypes();
  },
  methods: {
    ...mapActions('monitorTypes', ['fetchMonitorTypes']),
    ...mapActions('monitors', ['fetchMonitors']),
    ...mapMutations(['setLoading']),
    async query() {
      const url = `/monitorReport/${this.form.reportType}/${this.form.monitor}/${this.form.date}`;
      this.setLoading({ loading: true });
      try {
        const res = await axios.get(url);
        this.display = true;
        this.handleReport(res.data);
      } finally {
        this.setLoading({ loading: false });
      }
    },
    handleReport(report: any) {
      this.columns.splice(0, this.columns.length);
      if (this.form.reportType === 'daily') {
        this.columns.push({
          key: 'time',
          label: '時間',
          sortable: true,
        });
      } else {
        this.columns.push({
          key: 'time',
          label: '日期',
          sortable: true,
        });
      }
      for (let i = 0; i < report.columnNames.length; i++) {
        this.columns.push({
          key: `cellData[${i}].v`,
          label: `${report.columnNames[i]}`,
          sortable: true,
        });
      }
      for (const row of report.hourRows) {
        row.time =
          this.form.reportType === 'daily'
            ? moment(row.date).format('HH:mm')
            : moment(row.date).format('MM/DD');
      }
      this.rows = report.hourRows;
      this.statRows = report.statRows;
    },
  },
});
